module.exports = __webpack_public_path__ + "img/Gruppenführer_E.faae85f9.svg";